// 分块编辑操作按钮组（编辑/确定/取消），供申请信息各区块复用
export default {
  name: 'SectionEditActions',
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  render: function render(h) {
    var _this = this;
    var actions = this.editing ? [h('el-button', {
      class: 'project-info-action',
      props: {
        type: 'primary',
        loading: this.loading
      },
      on: {
        click: function click() {
          return _this.$emit('confirm');
        }
      }
    }, '确定'), h('el-button', {
      class: 'project-info-action',
      on: {
        click: function click() {
          return _this.$emit('cancel');
        }
      }
    }, '取消')] : [h('el-button', {
      class: 'project-info-action',
      props: {
        type: 'primary'
      },
      on: {
        click: function click() {
          return _this.$emit('start');
        }
      }
    }, '编辑')];
    return h('el-form-item', {
      class: 'sub-form-actions-item',
      props: {
        label: ''
      }
    }, actions);
  }
};